/*
  Shopify Asset: product-page.js
  Interactive client-side behavior for Jags Premium Product page layout
*/

(function() {
  'use strict';

  function initDynamicHeaderOffset() {
    function calculateOffset() {
      const headerSelectors = [
        '.premium-header',
        '.shopify-section-header',
        'header.site-header',
        'header',
        '#shopify-section-header',
        '.header-wrapper'
      ];
      let headerElement = null;
      for (const selector of headerSelectors) {
        const el = document.querySelector(selector);
        if (el && el.offsetHeight > 0) {
          headerElement = el;
          break;
        }
      }

      let totalHeight = 0;
      if (headerElement) {
        totalHeight = headerElement.getBoundingClientRect().height || headerElement.offsetHeight;
      } else {
        totalHeight = window.innerWidth <= 768 ? 90 : 130;
      }

      document.documentElement.style.setProperty('--dynamic-header-height', totalHeight + 'px');
      
      const wrapper = document.querySelector('.jags-product-wrapper');
      if (wrapper) {
        wrapper.style.setProperty('--dynamic-header-height', totalHeight + 'px');
      }
    }

    calculateOffset();
    window.addEventListener('load', calculateOffset);
    window.addEventListener('resize', calculateOffset);
    window.addEventListener('scroll', calculateOffset, { passive: true });

    // Mutation Observer to watch for banner height changes
    const observer = new MutationObserver(calculateOffset);
    const bodyEl = document.querySelector('body');
    if (bodyEl) {
      observer.observe(bodyEl, { attributes: true, childList: true, subtree: true });
    }

    let checkCount = 0;
    const interval = setInterval(() => {
      calculateOffset();
      checkCount++;
      if (checkCount > 10) clearInterval(interval);
    }, 300);
  }

  function initSwatchCarousel() {
    const list = document.querySelector('.jags-swatches-list');
    const leftArrow = document.querySelector('.jags-scroll-arrow-wrapper[data-navigation="left"]');
    const rightArrow = document.querySelector('.jags-scroll-arrow-wrapper[data-navigation="right"]');

    if (!list || !leftArrow || !rightArrow) return;

    const leftBtn = leftArrow.querySelector('.jags-scroll-arrow-btn');
    const rightBtn = rightArrow.querySelector('.jags-scroll-arrow-btn');

    if (leftBtn && rightBtn) {
      leftBtn.addEventListener('click', (e) => {
        e.preventDefault();
        list.scrollBy({ left: -140, behavior: 'smooth' });
      });

      rightBtn.addEventListener('click', (e) => {
        e.preventDefault();
        list.scrollBy({ left: 140, behavior: 'smooth' });
      });
    }

    function updateArrowVisibility() {
      const scrollLeft = list.scrollLeft;
      const maxScroll = list.scrollWidth - list.clientWidth;

      if (scrollLeft <= 5) {
        leftArrow.style.opacity = '0';
        leftArrow.style.pointerEvents = 'none';
      } else {
        leftArrow.style.opacity = '1';
        leftArrow.style.pointerEvents = 'auto';
      }

      if (scrollLeft >= maxScroll - 5) {
        rightArrow.style.opacity = '0';
        rightArrow.style.pointerEvents = 'none';
      } else {
        rightArrow.style.opacity = '1';
        rightArrow.style.pointerEvents = 'auto';
      }
    }

    list.addEventListener('scroll', updateArrowVisibility, { passive: true });
    window.addEventListener('resize', updateArrowVisibility);
    
    // Initial call after elements settle
    setTimeout(updateArrowVisibility, 300);
  }

  function initVariantSelection() {
    const section = document.querySelector('.jags-product-wrapper');
    if (!section) return;

    const sectionId = section.getAttribute('data-section-id');
    const hiddenIdInput = document.getElementById(`VariantIdHidden-${sectionId}`);
    const colorSwatches = document.querySelectorAll('.swatch-input-hidden');
    const sizePills = document.querySelectorAll('.size-input-hidden');
    const subtitleColor = document.getElementById(`ColorSubtitle-${sectionId}`);
    const galleryItems = document.querySelectorAll('.jags-gallery-item');

    // Parse product data
    const rawJsonEl = document.getElementById(`ProductJson-${sectionId}`);
    if (!rawJsonEl) return;
    
    let productData = {};
    try {
      productData = JSON.parse(rawJsonEl.textContent);
    } catch (e) {
      console.error("Failed to parse product data JSON", e);
      return;
    }

    function updateOptionsAvailability() {
      const activeColorSw = document.querySelector('.swatch-input-hidden:checked');
      const activeColor = activeColorSw ? activeColorSw.value : null;

      const hasColorOptions = document.querySelectorAll('.swatch-input-hidden').length > 0;

      // 1. Color Swatches availability
      colorSwatches.forEach(sw => {
        const colorName = sw.value;
        const isColorAvailable = productData.variants.some(v => v.options.includes(colorName) && v.available);
        const label = document.querySelector(`label[for="${sw.id}"]`) || sw.nextElementSibling;
        
        if (label) {
          if (!isColorAvailable) {
            label.style.opacity = '0.4';
            label.style.filter = 'grayscale(100%)';
            label.style.cursor = 'not-allowed';
            sw.disabled = true;
          } else {
            label.style.opacity = '';
            label.style.filter = '';
            label.style.cursor = 'pointer';
            sw.disabled = false;
          }
        }
      });

      // 2. Sizes availability depending on selected color
      sizePills.forEach(sz => {
        const sizeName = sz.value;
        const isSizeAvailable = productData.variants.some(v => {
          const colorOptionIndex = productData.options.findIndex(opt => opt.toLowerCase() === 'color' || opt.toLowerCase() === 'colour');
          const sizeOptionIndex = productData.options.findIndex(opt => opt.toLowerCase() === 'size');

          let match = true;
          if (hasColorOptions && colorOptionIndex !== -1 && activeColor) {
            match = match && (v.options[colorOptionIndex] === activeColor);
          }
          if (sizeOptionIndex !== -1) {
            match = match && (v.options[sizeOptionIndex] === sizeName);
          }
          return match && v.available;
        });
        const label = document.querySelector(`label[for="${sz.id}"]`) || sz.nextElementSibling;

        if (label) {
          if (!isSizeAvailable) {
            label.style.opacity = '0.35';
            label.style.cursor = 'not-allowed';
            label.style.borderColor = '#d9d9d9';
            label.style.backgroundColor = '#f7f7f7';
            label.style.color = '#a0a0a0';
            label.style.boxShadow = 'none';
            label.classList.add('no-hover');
            sz.disabled = true;
          } else {
            label.style.opacity = '';
            label.style.cursor = 'pointer';
            label.style.borderColor = '';
            label.style.backgroundColor = '';
            label.style.color = '';
            label.classList.remove('no-hover');
            sz.disabled = false;
          }
        }
      });
    }

    function handleSelectionChange() {
      const hasColorOptions = document.querySelectorAll('.swatch-input-hidden').length > 0;
      const hasSizeOptions = document.querySelectorAll('.size-input-hidden').length > 0;

      const activeColorSw = document.querySelector('.swatch-input-hidden:checked');
      const activeSizeSw = document.querySelector('.size-input-hidden:checked');

      if (hasColorOptions && !activeColorSw) return;
      if (hasSizeOptions && !activeSizeSw) return;

      const activeColor = activeColorSw ? activeColorSw.value : null;
      const activeSize = activeSizeSw ? activeSizeSw.value : null;

      // Update uppercase subtitle with color name
      if (subtitleColor && activeColor) {
        subtitleColor.textContent = activeColor.toUpperCase();
      }

      // Filter images inside dual gallery
      if (activeColor) {
        // 1. Gather all color values available in the swatches
        const allColorSwatches = Array.from(document.querySelectorAll('.swatch-input-hidden')).map(sw => sw.value.trim().toLowerCase());
        
        // 2. Check if ANY image in the gallery has an alt text that matches one of the color swatches
        let hasColorAltTags = false;
        galleryItems.forEach(item => {
          const itemAlt = (item.getAttribute('data-image-alt') || '').trim().toLowerCase();
          if (allColorSwatches.includes(itemAlt)) {
            hasColorAltTags = true;
          }
        });

        // 3. Filter images based on this condition
        galleryItems.forEach(item => {
          if (!hasColorAltTags) {
            // Fallback: If no image has a valid color ALT tag, show all images
            item.classList.remove('hidden-image');
          } else {
            const itemAlt = item.getAttribute('data-image-alt') || '';
            const normalizedAlt = itemAlt.trim().toLowerCase();
            const normalizedColor = activeColor.trim().toLowerCase();

            if (normalizedAlt === normalizedColor || normalizedAlt === '') {
              item.classList.remove('hidden-image');
            } else {
              item.classList.add('hidden-image');
            }
          }
        });
      }

      function formatMoney(cents) {
        const formattedCents = cents / 100;
        const priceDisplay = document.querySelector('.jags-price-display');
        let currencyPrefix = 'PKR ';
        if (priceDisplay) {
          const text = priceDisplay.textContent.trim();
          const firstDigit = text.search(/\d/);
          if (firstDigit > 0) {
            currencyPrefix = text.substring(0, firstDigit);
          }
        }
        return `${currencyPrefix}${formattedCents.toLocaleString('en-US')}`;
      }

      // Match selected variant
      const jagsCartBtn = document.querySelector('.jags-btn-cart');
      const jagsBuyBtn = document.querySelector('.jags-btn-buy');

      if (productData.variants) {
        const matchedVariant = productData.variants.find(v => {
          const colorOptionIndex = productData.options.findIndex(opt => opt.toLowerCase() === 'color' || opt.toLowerCase() === 'colour');
          const sizeOptionIndex = productData.options.findIndex(opt => opt.toLowerCase() === 'size');

          let match = true;
          if (colorOptionIndex !== -1 && activeColor) {
            match = match && (v.options[colorOptionIndex] === activeColor);
          }
          if (sizeOptionIndex !== -1 && activeSize) {
            match = match && (v.options[sizeOptionIndex] === activeSize);
          }
          return match;
        }) || (productData.variants.length === 1 ? productData.variants[0] : null);

        if (matchedVariant) {
          if (hiddenIdInput) {
            hiddenIdInput.value = matchedVariant.id;
          }

          // Update Buy and Add to Cart button states based on availability
          if (matchedVariant.available) {
            if (jagsCartBtn) {
              jagsCartBtn.disabled = false;
              jagsCartBtn.textContent = "Add to Cart";
              jagsCartBtn.classList.remove('disabled');
              jagsCartBtn.style.opacity = "";
              jagsCartBtn.style.pointerEvents = "";
              jagsCartBtn.style.cursor = "";
            }
            if (jagsBuyBtn) {
              jagsBuyBtn.disabled = false;
              jagsBuyBtn.classList.remove('disabled');
              jagsBuyBtn.style.opacity = "";
              jagsBuyBtn.style.pointerEvents = "";
              jagsBuyBtn.style.cursor = "";
            }
          } else {
            if (jagsCartBtn) {
              jagsCartBtn.disabled = true;
              jagsCartBtn.textContent = "Sold Out";
              jagsCartBtn.classList.add('disabled');
              jagsCartBtn.style.opacity = "0.5";
              jagsCartBtn.style.pointerEvents = "none";
              jagsCartBtn.style.cursor = "not-allowed";
            }
            if (jagsBuyBtn) {
              jagsBuyBtn.disabled = true;
              jagsBuyBtn.classList.add('disabled');
              jagsBuyBtn.style.opacity = "0.5";
              jagsBuyBtn.style.pointerEvents = "none";
              jagsBuyBtn.style.cursor = "not-allowed";
            }
          }

          // Update URL variant parameter
          const url = new URL(window.location);
          url.searchParams.set('variant', matchedVariant.id);
          window.history.replaceState({}, '', url.toString());

          // Update Price
          const priceDisplay = document.getElementById(`PriceDisplay-${sectionId}`);
          if (priceDisplay && matchedVariant.price) {
            priceDisplay.textContent = formatMoney(matchedVariant.price);
          }

          // Update Discount and Compare Price elements
          const discountDivider = document.getElementById(`DiscountDivider-${sectionId}`);
          const discountDisplay = document.getElementById(`DiscountDisplay-${sectionId}`);
          const compareContainer = document.getElementById(`CompareDisplayContainer-${sectionId}`);
          const compareDisplay = document.getElementById(`CompareDisplay-${sectionId}`);

          const priceVal = parseFloat(matchedVariant.price);
          const compareVal = parseFloat(matchedVariant.compare_at_price || matchedVariant.compare_price);

          if (compareVal && compareVal > priceVal) {
            const calculatedPercent = Math.round((1 - priceVal / compareVal) * 100);

            if (discountDisplay) {
              discountDisplay.textContent = `${calculatedPercent}% OFF`;
              discountDisplay.style.display = 'inline';
            }
            if (discountDivider) {
              discountDivider.style.display = 'inline';
            }
            if (compareDisplay) {
              compareDisplay.textContent = formatMoney(compareVal);
            }
            if (compareContainer) {
              compareContainer.style.display = 'block';
            }
          } else {
            if (discountDisplay) {
              discountDisplay.style.display = 'none';
            }
            if (discountDivider) {
              discountDivider.style.display = 'none';
            }
            if (compareContainer) {
              compareContainer.style.display = 'none';
            }
          }
          
          // Dispatch native form update event
          const form = hiddenIdInput.closest('form');
          if (form) {
            const event = new CustomEvent('variant:change', {
              detail: { variant: matchedVariant }
            });
            form.dispatchEvent(event);
          }
        } else {
          if (jagsCartBtn) {
            jagsCartBtn.disabled = true;
            jagsCartBtn.textContent = "Sold Out";
            jagsCartBtn.classList.add('disabled');
            jagsCartBtn.style.opacity = "0.5";
            jagsCartBtn.style.pointerEvents = "none";
            jagsCartBtn.style.cursor = "not-allowed";
          }
          if (jagsBuyBtn) {
            jagsBuyBtn.disabled = true;
            jagsBuyBtn.classList.add('disabled');
            jagsBuyBtn.style.opacity = "0.5";
            jagsBuyBtn.style.pointerEvents = "none";
            jagsBuyBtn.style.cursor = "not-allowed";
          }
        }
      }

      // Re-evaluate size availability for currently active selected color
      updateOptionsAvailability();
    }

    // Dynamic auto-size-selection handling on color change
    colorSwatches.forEach(sw => {
      sw.addEventListener('change', () => {
        const activeColor = sw.value;
        const activeSizeSw = document.querySelector('.size-input-hidden:checked');
        const activeSize = activeSizeSw ? activeSizeSw.value : null;

        // Find available sizes for selected color
        const availableSizes = productData.variants
          .filter(v => v.options.includes(activeColor) && v.available)
          .map(v => {
            return v.options.find(opt => opt !== activeColor);
          })
          .filter(Boolean);

        // Auto select first available size for this color if current size is not available
        if (availableSizes.length > 0 && (!activeSize || !availableSizes.includes(activeSize))) {
          const firstAvailSize = availableSizes[0];
          const firstAvailInput = Array.from(sizePills).find(p => p.value === firstAvailSize);
          if (firstAvailInput) {
            firstAvailInput.checked = true;
            firstAvailInput.dispatchEvent(new Event('change'));
          }
        }
      });
    });

    // Make sure we block interactions for disabled items
    colorSwatches.forEach(sw => {
      sw.addEventListener('click', e => {
        const isColorAvailable = productData.variants.some(v => v.options.includes(sw.value) && v.available);
        if (!isColorAvailable) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });
    });

    sizePills.forEach(sz => {
      sz.addEventListener('click', e => {
        const hasColorOptions = document.querySelectorAll('.swatch-input-hidden').length > 0;
        const activeColorSw = document.querySelector('.swatch-input-hidden:checked');
        const activeColor = activeColorSw ? activeColorSw.value : null;

        const isSizeAvailable = productData.variants.some(v => {
          const colorOptionIndex = productData.options.findIndex(opt => opt.toLowerCase() === 'color' || opt.toLowerCase() === 'colour');
          const sizeOptionIndex = productData.options.findIndex(opt => opt.toLowerCase() === 'size');

          let match = true;
          if (hasColorOptions && colorOptionIndex !== -1 && activeColor) {
            match = match && (v.options[colorOptionIndex] === activeColor);
          }
          if (sizeOptionIndex !== -1) {
            match = match && (v.options[sizeOptionIndex] === sz.value);
          }
          return match && v.available;
        });

        if (!isSizeAvailable) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });
    });

    colorSwatches.forEach(sw => sw.addEventListener('change', handleSelectionChange));
    sizePills.forEach(sz => sz.addEventListener('change', handleSelectionChange));

    // Form submission safety guard
    const jagsAddToCartForm = document.getElementById('JagsAddToCartForm');
    if (jagsAddToCartForm) {
      jagsAddToCartForm.addEventListener('submit', function(e) {
        const hasColorOptions = document.querySelectorAll('.swatch-input-hidden').length > 0;
        const hasSizeOptions = document.querySelectorAll('.size-input-hidden').length > 0;

        const activeColorInput = document.querySelector('.swatch-input-hidden:checked');
        const activeSizeInput = document.querySelector('.size-input-hidden:checked');

        if (hasColorOptions && !activeColorInput) {
          e.preventDefault();
          return false;
        }
        if (hasSizeOptions && !activeSizeInput) {
          e.preventDefault();
          return false;
        }

        const activeColor = activeColorInput ? activeColorInput.value : null;
        const activeSize = activeSizeInput ? activeSizeInput.value : null;

        const matchedVariant = productData.variants.find(v => {
          const colorOptionIndex = productData.options.findIndex(opt => opt.toLowerCase() === 'color' || opt.toLowerCase() === 'colour');
          const sizeOptionIndex = productData.options.findIndex(opt => opt.toLowerCase() === 'size');

          let match = true;
          if (colorOptionIndex !== -1 && activeColor) {
            match = match && (v.options[colorOptionIndex] === activeColor);
          }
          if (sizeOptionIndex !== -1 && activeSize) {
            match = match && (v.options[sizeOptionIndex] === activeSize);
          }
          return match;
        }) || (productData.variants.length === 1 ? productData.variants[0] : null);

        if (!matchedVariant || !matchedVariant.available) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });
    }

    // Run on initial load to set up starting availability visual styles
    updateOptionsAvailability();
    handleSelectionChange();
  }

  // Bind loaders
  document.addEventListener('DOMContentLoaded', () => {
    initDynamicHeaderOffset();
    initSwatchCarousel();
    initVariantSelection();
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      initDynamicHeaderOffset();
      initSwatchCarousel();
      initVariantSelection();
    });
  }
})();
